<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>

<template>
  <div style="height:100%;padding:5px;text-align:center;">
    <Modal title="Title" v-model="showModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#ff9900;text-align:center">
        <span>用户载入</span>
      </p>
      <div style="text-align:center">
        <span>{{ selectBindMsg }}</span>
      </div>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <Select
            v-model="selectedIdentity"
            style="margin-left:10px; width:200px"
            placeholder="请选择加载身份"
          >
            <Option
              v-if="customerObject != undefined && customerObject.length > 0"
              value="householder"
              >户主用户</Option
            >
            <Option
              v-if="meterInfo != undefined && meterInfo.length > 0"
              value="nothouseholder"
              >非户主用户</Option
            >
            <Option
              v-if="personnelObject != undefined && personnelObject.length > 0"
              value="personnel"
              >工程人员</Option
            >
            <!-- <Option v-if="true" value="householder">户主用户</Option>
            <Option v-if="true" value="nothouseholder">非户主用户</Option>
            <Option v-if="true" value="personnel">工程人员</Option>-->
          </Select>
        </div>
        <div style="margin-bottom: 10px">
          <Select
            v-if="selectedIdentity == 'personnel'"
            v-model="selectedPersonnel"
            style="margin-left:10px; width:200px"
            placeholder="请选择工程人员"
          >
            <Option
              v-for="(value, key) in personnelObject"
              :value="value"
              :key="key"
              >{{ value.personnelIdcard + " " + value.personnelName }}</Option
            >
          </Select>
        </div>
        <div style="margin-bottom: 10px">
          <Select
            v-if="selectedIdentity == 'householder'"
            v-model="selectedCustomer"
            style="margin-left:10px; width:200px"
            placeholder="请选择户主用户"
          >
            <Option
              v-for="(value, key) in customerObject"
              :value="value"
              :key="key"
              >{{ value.customerIdcard + " " + value.customerName }}</Option
            >
          </Select>
        </div>
      </div>
      <div slot="footer">
        <Button
          :loading="isLoading"
          type="warning"
          size="large"
          @click="selectIdentityClick"
          long
          >确认</Button
        >
      </div>
    </Modal>

    <Spin fix v-show="isSpinShow" size="large" />
    <Affix :offset-top="0">
      <div class="top-c">
        <header>
          <Button
            class="h-left"
            @click="showDrawer = true"
            shape="circle"
            icon="ios-apps"
            >功能列表</Button
          >
          <div class="h-right">
            <!-- 下拉菜单 -->
            <Dropdown
              trigger="click"
              @on-click="userOperate"
              @on-visible-change="showArrow"
            >
              <div class="pointer" style="text-align:right">
                <div>
                  <!-- 用户头像 -->
                  <label class="user-img-c" style="text-align:right">
                    <Icon v-if="isPersonnel" type="ios-construct" />
                    <Icon v-if="isCustomer" type="ios-contact" />
                  </label>
                  <span>{{ userName }}</span>
                  <Icon v-show="arrowDown" type="md-arrow-dropdown" />
                  <Icon v-show="arrowUp" type="md-arrow-dropup" />
                </div>
                <span v-if="!isPersonnel">{{ currentMeterInfo.meterId }}</span>
              </div>
              <DropdownMenu slot="list">
                <!-- name标识符 -->
                <DropdownItem name="1">切换身份</DropdownItem>
                <DropdownItem name="2">身份绑定</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </header>
      </div>
    </Affix>
    <div v-if="show.characteristic">
      <characteristic ref="characteristic"></characteristic>
    </div>
    <div v-show="show.barCode">
      <barCode ref="barCode"></barCode>
    </div>
    <div v-show="show.generalOCR">
      <generalOCR ref="generalOCR"></generalOCR>
    </div>
    <div v-show="show.userBind">
      <userBind :call-back="userBindCallBack" ref="userBind"></userBind>
    </div>
    <div v-if="show.install">
      <install ref="install"></install>
    </div>
    <div v-show="show.selectMeter">
      <selectMeter
        :customerInfo="selectedCustomer"
        :selectedIdentity="selectedIdentity"
        :selectedCustomer="selectedCustomer"
        :callBack="selectMeterCallBack"
        ref="selectMeter"
      ></selectMeter>
    </div>
    <div v-if="show.daily">
      <daily ref="daily"></daily>
    </div>
    <div v-if="show.measurement">
      <measurement
        :meterId="currentMeterInfo.meterId"
        ref="measurement"
      ></measurement>
    </div>
    <div v-if="show.rechargeRecord">
      <rechargeRecord
        :meterId="currentMeterInfo.meterId"
        ref="rechargeRecord"
      ></rechargeRecord>
    </div>
    <div v-show="show.meterParam">
      <meterParam ref="meterParam"></meterParam>
    </div>
    <div v-show="show.safeGas">
      <safeGas ref="safeGas"></safeGas>
    </div>
    <div v-show="show.rechargeWechat">
      <rechargeWechat ref="rechargeWechat"></rechargeWechat>
    </div>
    <div v-show="show.monthGasRecord">
      <monthGasRecord ref="monthGasRecord"></monthGasRecord>
    </div>
    <div v-show="show.ladderPrice">
      <ladderPrice ref="ladderPrice"></ladderPrice>
    </div>
    <div v-show="show.userResponse">
      <userResponse ref="userResponse"></userResponse>
    </div>
    <div v-show="show.valve">
      <valve ref="valve"></valve>
    </div>
    <div v-show="show.abnormal">
      <abnormal ref="abnormal"></abnormal>
    </div>
    <div v-show="show.airkiss">
      <airkiss ref="airkiss"></airkiss>
    </div>
    <div v-show="show.gasapplication">
      <gasapplication ref="gasapplication"></gasapplication>
    </div>
    <div v-if="show.sgbind">
      <sgbind ref="sgbind"></sgbind>
    </div>
    <div v-if="show.debind">
      <debind
        :customerArray="customerObject"
        :personnelArray="personnelObject"
        :meterArray="meterInfo"
        :call-back="userdeBindCallBack"
        ref="debind"
      ></debind>
    </div>

    <div v-show="show.index">
      <Scroll :height="height * 0.9">
        <div>
          <Carousel v-model="value2" :loop="false">
            <CarouselItem>
              <div class="carousel">
                <img style="width:100%" :src="dc1" />
              </div>
            </CarouselItem>
            <CarouselItem>
              <div class="carousel">
                <img style="width:100%" :src="dc2" />
              </div>
            </CarouselItem>
            <CarouselItem>
              <div class="carousel">
                <img style="width:100%" :src="dc3" />
              </div>
            </CarouselItem>
          </Carousel>
        </div>
        <div style="width:100%">
          <Card style="width:100%">
            <div style="text-align:center">
              <img style="width:30%" :src="logo" />
              <h3 style="color:#2b85e4">关于我们 About Us</h3>
              <Divider />
              <p style="text-align:left">
                &emsp;山东拙诚智能科技有限公司成立于2016年2月，
                主要从事燃气计量设备、燃气安全与智能设备、燃气系统综合管理软件的研发、生产和销售。
                在燃气智能化与安全领域，拙诚取得了诸多高水平的研发成果，拥有多项自主知识产权。公司
                的技术和产品以杜绝燃气事故、提供安全与智能的燃气设备为出发点，契合国家产业政策和社
                会生活需要，具有广阔的市场前景。
              </p>
            </div>
          </Card>
        </div>
      </Scroll>
    </div>
    <Drawer title placement="left" :closable="false" v-model="showDrawer">
      <Menu :theme="theme" active-name="1" @on-select="selectMenu">
        <MenuGroup title="首页">
          <MenuItem name="index"> <Icon type="md-document" />首页 </MenuItem>
          <MenuItem name="debind">
            <Icon type="md-document" />绑定管理
          </MenuItem>
        </MenuGroup>
        <MenuItem name="airkiss"> <Icon type="md-home" />wifi配置 </MenuItem>
        <MenuGroup title="设备设置" v-if="isCustomer">
          <MenuItem name="selectMeter">
            <Icon type="md-leaf" />选择设备
          </MenuItem>
          <MenuItem
            name="meterParam"
            v-if="selectedIdentity != 'nothouseholder'"
          >
            <Icon type="md-leaf" />设备参数
          </MenuItem>
          <MenuItem name="safeGas" v-if="selectedIdentity != 'nothouseholder'">
            <Icon type="md-leaf" />安全用气
          </MenuItem>
          <MenuItem name="rechargeWechat">
            <Icon type="md-leaf" />充值
          </MenuItem>
        </MenuGroup>
        <MenuGroup title="设备维护" v-if="isPersonnel">
          <!-- <MenuGroup title="设备维护" v-if="true"> -->
          <MenuItem name="install"> <Icon type="md-heart" />工单处理 </MenuItem>
          <MenuItem name="characteristic">
            <Icon type="md-leaf" />特征值
          </MenuItem>
          <!-- <MenuItem name="airkiss"> <Icon type="md-leaf" />wifi配置 </MenuItem> -->
          <!-- <MenuItem name="barCode">
            <Icon type="md-leaf" />条码扫描
          </MenuItem>-->
          <MenuItem name="sgbind">
            <Icon type="md-leaf" />设备信息绑定
          </MenuItem>
        </MenuGroup>
        <MenuGroup title="记录查询" v-if="isCustomer">
          <MenuItem name="measurementMenu">
            <Icon type="md-heart" />余额查询
          </MenuItem>
          <MenuItem name="rechargeRecord">
            <Icon type="md-heart" />缴费记录
          </MenuItem>
          <MenuItem name="dailyrecord">
            <Icon type="md-heart" />用气记录
          </MenuItem>
          <MenuItem name="monthGasRecord">
            <Icon type="md-leaf" />月用气记录
          </MenuItem>
          <MenuItem name="abnormal">
            <Icon type="md-heart" />异常记录
          </MenuItem>
          <MenuItem name="valve"> <Icon type="md-heart" />开关阀记录 </MenuItem>
          <MenuItem name="ladderPrice">
            <Icon type="md-heart" />阶梯气价
          </MenuItem>
        </MenuGroup>
        <MenuGroup title="用户中心" v-if="isCustomer">
          <MenuItem
            name="userResponse"
            v-if="selectedIdentity != 'nothouseholder'"
          >
            <Icon type="md-home" />信息反馈
          </MenuItem>
          <!-- <MenuItem name="airkiss"> <Icon type="md-home" />wifi配置 </MenuItem> -->
          <MenuItem
            name="gasapplication"
            v-if="selectedIdentity != 'nothouseholder'"
          >
            <Icon type="md-home" />燃气用具管理
          </MenuItem>
        </MenuGroup>
      </Menu>
    </Drawer>
  </div>
</template>
<script>
import characteristic from "../Characteristic.vue";
import userBind from "./UserBind.vue";
import install from "../wechat/Install.vue";
import daily from "../wechat/DailyGasRecord.vue";
import measurement from "../wechat/Measurement.vue";
import rechargeRecord from "../wechat/RechargeRecord.vue";
import ladderPrice from "../wechat/LadderPrice.vue";
import userResponse from "../wechat/UserResponse.vue";
import selectMeter from "./SelectSelfMeterModal.vue";
import abnormal from "../wechat/AbnormalRecord.vue";
import valve from "../wechat/ValveRecord.vue";
import airkiss from "../wechat/AirKiss.vue";
import gasapplication from "../wechat/GasApplication.vue";
import barCode from "../wechat/BarCode.vue";
import generalOCR from "../wechat/GeneralOCR.vue";
import sgbind from "../wechat/SGBind.vue";
import debind from "../wechat/UserDeBind.vue";
import meterParam from "../wechat/MeterParam.vue";
import safeGas from "../wechat/SafeGas.vue";
import rechargeWechat from "../wechat/RechargeWechat.vue";
import monthGasRecord from "../wechat/MonthGasRecord.vue";

export default {
  components: {
    install,
    characteristic,
    userBind,
    daily,
    selectMeter,
    measurement,
    rechargeRecord,
    ladderPrice,
    userResponse,
    abnormal,
    valve,
    airkiss,
    gasapplication,
    barCode,
    generalOCR,
    sgbind,
    debind,
    meterParam,
    safeGas,
    rechargeWechat,
    monthGasRecord
  },
  created() {},
  methods: {
    selectMeterCallBack(meterInfo, target) {
      this.currentMeterInfo = JSON.parse(meterInfo);
      // 如果是单纯的绑定设备，跳回主页
      if (target == "selectMeter") {
        target = "index";
      }
      // 返回原菜单选项指向的页面
      this.selectMenu(target);
    },
    selectMenu(menuName) {
      this.hideAllView();
      var menuTarget = menuName;
      if (
        (typeof this.currentMeterInfo.meterId == "undefined" ||
          this.currentMeterInfo.meterId == null ||
          this.currentMeterInfo.meterId == "") &&
        this.userMenu.indexOf(menuTarget) > 0
      ) {
        //如果菜单跳转至用户目录然而设备号未找到则跳转至选择设备页面
        menuTarget = "selectMeter";
      }
      switch (menuTarget) {
        case "index":
          this.show.index = true;
          break;
        case "install":
          this.show.install = true;
          if (this.$refs.install) {
            this.$refs.install.getOrderList();
          }
          break;
        case "characteristic":
          this.show.characteristic = true;
          break;
        case "barCode":
          this.show.barCode = true;
          break;
        case "generalOCR":
          this.show.generalOCR = true;
          break;
        case "selectMeter":
          this.show.selectMeter = true;
          this.$refs.selectMeter.initModal(menuName);
          break;
        case "dailyrecord":
          this.show.daily = true;
          if (this.$refs.daily) {
            this.$refs.daily.clearData();
            this.$refs.daily.meterId = this.currentMeterInfo.meterId;
            this.$refs.daily.getDailyRecord();
          }

          break;
        case "measurementMenu":
          this.show.measurement = true;
          if (this.$refs.measurement) {
            this.$refs.measurement.getMeasurementRecord(
              this.currentMeterInfo.meterId
            );
          }
          break;
        case "rechargeRecord":
          this.show.rechargeRecord = true;
          if (this.$refs.rechargeRecord) {
            this.$refs.rechargeRecord.getRecordPage(
              this.currentMeterInfo.meterId
            );
          }
          break;
        case "meterParam":
          this.show.meterParam = true;
          this.$refs.meterParam.getDownInstruction(
            this.currentMeterInfo.meterId
          );
          break;
        case "safeGas":
          this.show.safeGas = true;
          this.$refs.safeGas.getDownInstruction(this.currentMeterInfo.meterId);
          break;
        case "rechargeWechat":
          this.show.rechargeWechat = true;
          this.$refs.rechargeWechat.setMeter(this.currentMeterInfo.meterId);
          break;
        case "monthGasRecord":
          this.show.monthGasRecord = true;
          this.$refs.monthGasRecord.setMeter(this.currentMeterInfo.meterId);
          break;
        case "ladderPrice":
          this.show.ladderPrice = true;
          this.$refs.ladderPrice.getRechargeBaseInfo(
            this.currentMeterInfo.meterId
          );
          break;
        case "userResponse":
          this.show.userResponse = true;
          console.log(this.currentMeterInfo);
          this.$refs.userResponse.showCustomerDetails(this.currentMeterInfo);
          break;
        case "abnormal":
          this.show.abnormal = true;
          if (this.$refs.abnormal) {
            this.$refs.abnormal.clearData();
            this.$refs.abnormal.requestBody.meterId = this.currentMeterInfo.meterId;
            this.$refs.abnormal.getAbnormalRecord();
            this.show.abnormal = true;
          }
          break;
        case "valve":
          this.show.valve = true;
          if (this.$refs.valve) {
            this.$refs.valve.clearData();
            this.$refs.valve.meterId = this.currentMeterInfo.meterId;
            this.$refs.valve.getvalveRecord();
            this.show.valve = true;
          }
          break;
        case "airkiss":
          this.loadAirKiss();
          this.show.index = true;
          break;
        case "gasapplication":
          this.$refs.gasapplication.setMeterId(this.currentMeterInfo.meterId);
          this.show.gasapplication = true;
          break;
        case "sgbind":
          this.show.sgbind = true;
          break;
        case "debind":
          this.show.debind = true;
          break;
      }
      this.showDrawer = false;
    },
    loadAirKiss() {
      var that = this;
      that.isSpinShow = true;
      var thisUrl = encodeURIComponent(location.href);
      $.ajax({
        url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
        contentType: "application/json",
        type: "get",
        async: true,
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          wx.config({
            beta: true, // 开启内测接口调用，注入wx.invoke方法
            debug: false, // 开启调试模式，关闭
            appId: receiveData.body.appId, // 必填，公众号的唯一标识
            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
            signature: receiveData.body.signature, // 必填，签名
            jsApiList: ["configWXDeviceWiFi"] // 需要使用的jsapi列表
          });

          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ["configWXDeviceWiFi"],
              success: function(res) {
                wx.invoke("configWXDeviceWiFi", {}, function(res) {
                  var err_msg = res.err_msg;
                  console.log(err_msg);
                  // alert(err_msg);
                  if (err_msg == "configWXDeviceWiFi:ok") {
                    console.log("ok");
                    return;
                  } else {
                    alert("您的手机不支持当前功能");
                  }
                });
              }
            });
          });
          console.log(receiveData);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    getUserInfo(code) {
      var callUrl = "/api/getUserInfo";
      if (code != undefined) {
        callUrl = callUrl + "?visitWay=wx&code=" + code;
      }
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: callUrl,
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            if (data.body) {
              if (data.body.personnelArray != undefined) {
                // 当前用户微信未进行绑定
                that.$Modal.info({
                  title: "提示",
                  content: "请先进行用户绑定"
                });
              } else {
                that.$Modal.error({
                  title: "异常",
                  content: "微信认证失败，请稍后再试"
                });
              }
            } else {
              that.$Modal.error({
                title: "异常",
                content: data.errorInfo
              });
            }
            that.isSpinShow = false;
            return;
          }

          var personnelObject = data.body.personnelObject;
          var customerObject = data.body.customerObject;
          var meterInfo = data.body.meterInfo;
          var currentType = data.body.currentType;

          

          if (
            (personnelObject == undefined || personnelObject.length == 0) &&
            (customerObject == undefined || customerObject.length == 0) &&
            (meterInfo == undefined || meterInfo.length == 0)
          ) {
            that.selectBindMsg = "您没有任何身份信息，请先进行绑定";
            // 当前用户微信未进行绑定
            that.$Modal.info({
              title: "提示",
              content: "您没有任何身份信息，请先进行绑定"
            });
          }

          if(customerObject.length > 30 && personnelObject.length > 30){
            that.selectBindMsg = "身份信息获取错误，请重新进入页面";
            // 当前用户微信未进行绑定
            that.$Modal.info({
              title: "提示",
              content: "身份信息获取错误，请重新进入页面"
            });
            return;
          }

          that.personnelObject = personnelObject;
          that.customerObject = customerObject;
          that.meterInfo = meterInfo;
          that.currentType = currentType;

          that.isCustomer = false;
          that.isPersonnel = false;
          that.userName = "";
          that.selectedIdentity = "";

          if (personnelObject.length > 0) {
            that.selectedIdentity = "personnel";
            that.isPersonnel = true;
            that.userName = personnelObject[0].personnelName;
          } else if (customerObject.length > 0) {
            that.selectedIdentity = "householder";
            that.selectedCustomer = customerObject[0];
            that.isCustomer = true;
            // that.$refs.selectMeter.initModal("index");
            that.userName = customerObject[0].customerName;
          } else if (meterInfo.length > 0) {
            that.selectedIdentity = "nothouseholder";
            that.isCustomer = true;
            // that.$refs.selectMeter.initModal("index");
            that.userName = "非户主用户";
          }

          console.log(currentType);

          if (currentType == "1") {
            that.selectBindMsg = "您已绑定 工程人员 请选择欲载入信息";
            // that.showModal = true;
          }

          if (currentType == "2") {
            that.selectBindMsg = "您已绑定 户主用户 请选择欲载入信息";
            // that.showModal = true;
          }
          if (currentType == "3") {
            that.selectBindMsg =
              "您已绑定 工程人员 及 户主用户 请选择欲载入信息";
            // that.showModal = true;
          }

          if (currentType == "4") {
            that.selectBindMsg = "您已绑定 非户主用户 请选择欲载入信息";
            // that.showModal = true;
          }

          if (currentType == "5") {
            that.selectBindMsg =
              "您已绑定 工程人员 非户主用户 请选择欲载入信息";
            // that.showModal = true;
          }

          if (currentType == "6") {
            that.selectBindMsg =
              "您已绑定 户主用户 及 非户主用户 请选择欲载入信息";
            // that.showModal = true;
          }
          if (currentType == "7") {
            that.selectBindMsg =
              "您已绑定 工程人员 户主用户 及 非户主用户 请选择欲载入信息";
            // that.showModal = true;
          }
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    selectIdentityClick() {
      if (this.selectedIdentity == "") {
        this.$Modal.info({
          title: "提示",
          content: "请选择身份类型！"
        });
        return;
      }

      this.isPersonnel = false;
      this.isCustomer = false;
      this.userName = "";
      this.currentMeterInfo.meterId = "";

      if (this.selectedIdentity == "personnel") {
        if (this.selectedPersonnel == "") {
          this.$Modal.info({
            title: "提示",
            content: "请选择工程人员！"
          });
          return;
        }
        this.isPersonnel = true;
        console.log(this.selectedPersonnel);
        this.userName = this.selectedPersonnel.personnelName;
        this.showModal = false;
      } else {
        if (
          this.selectedCustomer == "" &&
          this.selectedIdentity == "householder"
        ) {
          this.$Modal.info({
            title: "提示",
            content: "请选择用户人员！"
          });
          return;
        }
        this.isCustomer = true;
        this.showModal = false;

        this.$refs.selectMeter.initModal("index");
        this.show.selectMeter = true;

        if (this.selectedIdentity == "nothouseholder") {
          this.userName = "非户主用户";
        } else {
          this.userName =
            this.selectedCustomer.customerName == undefined
              ? ""
              : this.selectedCustomer.customerName;
        }
      }

      this.hideAllView();
      this.show.index = true;
    },

    userdeBindCallBack(userInfoObject) {
      // this.hideAllView();
      // this.show.index = true;
      this.userName = "";
      this.isPersonnel = false;
      this.isCustomer = false;
      this.selectedIdentity = "";
      this.currentMeterInfo.meterId = "";
      this.getUserInfo();
      // this.showModal = true;
    },
    userBindCallBack(userInfoObject) {
      this.getUserInfo();
      this.hideAllView();
      this.show.index = true;
      // this.isCustomer = false;
      // this.isPersonnel = false;
      // var name = "";
      // if (userInfoObject.body.customerArray.length != 0) {
      //   name = userInfoObject.body.customerArray[0].customerName;
      // }
      // if (userInfoObject.body.personnelArray.length != 0) {
      //   name = userInfoObject.body.personnelArray[0].personnelName;
      // }
      // this.userName = name;
      // if (userInfoObject.body.isCustomer) {
      //   this.isCustomer = true;
      //   this.hasBindCustomer = true;
      // } else if (userInfoObject.body.isPersonnel) {
      //   this.isPersonnel = true;
      //   this.hasBindPersonnel = true;
      // }
      // this.show.userBind = false;
      // this.show.index = true;
    },
    // 控制用户三角箭头显示状态
    showArrow(flag) {
      this.arrowUp = flag;
      this.arrowDown = !flag;
    },
    hideAllView() {
      var that = this;
      Object.keys(that.show).forEach(function(key) {
        that.show[key] = false;
      });
    },
    // 用户操作
    userOperate(name) {
      switch (name) {
        case "1":
          // 切换身份
          this.showModal = true;
          break;
        case "2":
          // 身份绑定
          this.hideAllView();

          this.show.userBind = true;
          break;
      }
    }
  },
  data() {
    return {
      theme: "light",
      currentMeterInfo: {},
      personnelObject: {},
      customerObject: {},
      meterInfo: [],
      currentType: "",
      isSpinShow: false,
      selectBindMsg: "请选择您即将载入的身份信息",
      selectedIdentity: "",
      showModal: false,
      isLoading: false,
      selectedPersonnel: "",
      selectedCustomer: "",
      show: {
        userBind: false,
        _install: false,
        get install() {
          return this._install;
        },
        set install(value) {
          this._install = value;
        },
        characteristic: false,
        barCode: false,
        generalOCR: false,
        index: true,
        selectMeter: false,
        daily: false,
        measurement: false,
        rechargeRecord: false,
        meterParam: false,
        safeGas: false,
        rechargeWechat: false,
        monthGasRecord: false,
        ladderPrice: false,
        userResponse: false,
        abnormal: false,
        valve: false,
        airkiss: false,
        gasapplication: false,
        sgbind: false,
        debind: false
      },
      customerInfo: {},
      userName: "",
      value2: 1,
      isPersonnel: false,
      isCustomer: false,
      hasBindPersonnel: false,
      hasBindCustomer: false,
      arrowUp: false, // 用户详情向上箭头
      arrowDown: true, // 用户详情向下箭头
      showDrawer: false,
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      dc1: require("../../assets/imgs/c1.jpg"),
      dc2: require("../../assets/imgs/c2.jpg"),
      dc3: require("../../assets/imgs/c3.jpg"),
      logo: require("../../assets/imgs/logo.jpg"),
      userMenu: [
        "selectMeter",
        "dailyrecord",
        "measurementMenu",
        "rechargeRecord",
        "meterParam",
        "safeGas",
        "rechargeWechat",
        "monthGasRecord",
        "ladderPrice",
        "userResponse",
        "abnormal",
        "valve",
        "gasapplication"
      ]
    };
  }
};
</script>
<style scoped>
.carousel {
  height: 200px;
  line-height: 200px;
  text-align: center;
  color: #fff;
  font-size: 20px;
  background: #506b9e;
}
.carousel img {
  height: 100%;
}
.index-vue {
  height: 100%;
  display: flex;
  justify-content: space-between;
  color: #666;
}
/* 侧边栏 */
aside {
  min-width: 80px;
  background: #20222a;
  height: 100%;
  transition: all 0.5s;
  overflow: auto;
}
.logo-c {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  margin: 20px 0;
  justify-content: center;
}
.logo {
  width: 40px;
  margin-right: 10px;
}
.aside-big {
  min-width: 220px;
}
/* 主体页面 */
.sec-right {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: width 0.5s;
}
/* 主体页面头部 */
.top-c {
  background: rgba(230, 230, 230, 0.5);
  width: 100%;
}
header {
  height: 50px;
  border-bottom: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
  padding-left: 10px;
  font-size: 14px;
}
header .ivu-icon {
  font-size: 20px;
}
.refresh-c {
  margin: 0 30px;
  cursor: pointer;
}
.h-right {
  position: absolute;
  display: flex;
  align-items: center;
  right: 35px;
}
.h-left {
  display: flex;
  align-items: center;
}
.user-img-c img {
  width: 100%;
}
.notice-c {
  cursor: pointer;
  position: relative;
}
.newMsg {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff5722;
  right: 0;
  top: 0;
}
.user-img-c {
  padding-top: 2px;
  padding-bottom: 3px;
  margin-right: 10px;
  width: 23px;
  height: 23px;
  background: #fff;
  color: #000;
  font-size: 8px;
  border-radius: 50%;
  overflow: hidden;
}
.tag-options {
  cursor: pointer;
  position: relative;
}
.div-tags {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.div-icons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  height: 34px;
  width: 160px;
  font-size: 18px;
}
/* 标签栏 */
.ul-c {
  height: 34px;
  margin-top: 2px;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px;
  overflow: hidden;
  width: calc(100% - 160px);
}
.ul-c li {
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  height: 24px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 3px 5px 2px 3px;
  border: 1px solid #e6e6e6;
}
a {
  color: #666;
  transition: none;
}
.li-a {
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ul-c .ivu-icon {
  margin-left: 6px;
}
.active {
  background: #409eff;
  border: 1px solid #409eff;
}
.active a {
  color: #fff;
}
.active .ivu-icon {
  color: #fff;
}
/* 主要内容区域 */
.main-content {
  overflow: auto;
  height: 100%;
  width: 100%;
  background: #eee;
  padding: 10px 12px;
}
.view-c {
  position: relative;
  background: #fff;
  padding: 15px;
}
.pointer {
  cursor: pointer;
}
/* loading */
.loading-c {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mask {
  position: fixed;
  background: #eee;
  height: 10px;
  width: 100%;
  top: 85px;
  z-index: 10;
}
.crumbs {
  margin-left: 10px;
  color: #97a8be;
  cursor: default;
}
.menu-level-3 .ivu-icon {
  font-size: 18px;
}
</style>
